import * as React from 'react';
import PageConfig from 'ts/services/userflow/PageConfig';
import { ErrorFlow } from 'ts/passwordless-login/components/pages/error/ErrorFlow';
import { SetYourPasswordPage } from 'ts/passwordless-login/components/pages/set-your-password/SetYourPasswordPage';
import { ROUTES } from 'ts/Routes';
import { RouteComponentProps } from 'react-router-dom';
import { navigateToErrorPage } from 'ts/passwordless-login/components/pages/error/ErrorNavigation';

const pageConfig: PageConfig = {
  errorType: ErrorFlow.profileChangePassword,
  startRoute: ROUTES.CHANGE_PASSWORD,
  analytics: {
    pageName: 'update-password',
    taskName: 'my-account:update-password',
  },
};

export const ChangePasswordPage: React.FC<RouteComponentProps> = ({ history, location }) => (
  <SetYourPasswordPage
    authenticated={true}
    headingText="Change your password"
    messageText="This will replace the password you used to log into your account."
    config={pageConfig}
    nextAction={() =>
      history.push({ pathname: ROUTES.CHANGE_PASSWORD_SUCCESS, search: location.search })
    }
    navigateToErrorPage={() => {
      // need to go back to return to url on error as
      // we cant use the reset pw url multiple times
      const returnToUrl = new URLSearchParams(location.search).get('returnTo');
      navigateToErrorPage('change_password_error', ErrorFlow.profileChangePassword, returnToUrl);
    }}
  />
);
